import type { faceAttributeValue as FaceAttributes, Profile } from "@nuralogix.ai/web-measurement-embedded-app";
import { WmeaProfile } from "../../Services/Wmea";

export function sdkProfile(profile: WmeaProfile, faceAttributeValue: typeof FaceAttributes): Profile {
  return {
    age: profile.age, heightCm: profile.height, weightKg: profile.weight,
    sex: profile.gender === "male" ? faceAttributeValue.SEX_ASSIGNED_MALE_AT_BIRTH : faceAttributeValue.SEX_ASSIGNED_FEMALE_AT_BIRTH,
    smoking: profile.smoking === "1" ? faceAttributeValue.SMOKER_TRUE : faceAttributeValue.SMOKER_FALSE,
    bloodPressureMedication: profile.bloodpressuremedication === "1" ? faceAttributeValue.BLOOD_PRESSURE_MEDICATION_TRUE : faceAttributeValue.BLOOD_PRESSURE_MEDICATION_FALSE,
    diabetes: { "0": faceAttributeValue.DIABETES_NONE, type1: faceAttributeValue.DIABETES_TYPE1, type2: faceAttributeValue.DIABETES_TYPE2 }[profile.diabetes],
    // In 1.1.0 true means a profile-less measurement (it does NOT skip just the form).
    bypassProfile: false,
  };
}
